<template>
  <div name="demo-table-inline-delete">
    <hrms-table :columns="columns[nowLang].index"
                :data="index"
                :maxRowspan="maxRowspan"
                :deleteInlineEventBool="true"
                :saveInlineEvent="showFlgDetails"
                :columnEvent="columnEvent" />

    <div class="col-xs-12 col-md-6">
      <div class="form-group-button">
        <div class="btn button-in-search bg-dark-gray" @click="refresh()"><i class="fa fa-refresh"></i>Refresh</div>
      </div>
    </div>

    <template v-if="objs.delete.rows.length > 0">
      <h3>{{desc.delete}}</h3>
      <hrms-table :columns="columns[nowLang].index"
                  :data="objs.delete"
                  :maxRowspan="maxRowspan" />
    </template>
  </div>
</template>

<script>
import mock from './mockTableData.js'

let labels = mock.inlineLabels
let flgRowCondition = false
let mockColumns = mock.columns(labels, 'delete', flgRowCondition)
let mockMaxRowspan = 2
let mockData = mock.dataInline(flgRowCondition)

export default {
  name: 'demo-table-inline-delete',
  data () {
    return {
      nowLang: 'en',
      columns: {
        en: { index: mockColumns },
        th: { index: mockColumns }
      },
      index: mockData,
      maxRowspan: mockMaxRowspan,
      objs: {
        delete: {
          total: 0,
          rows: []
        }
      },
      desc: {
        delete: ''
      }
    }
  },
  methods: {
    refresh () {
      this.index = mockData
    },
    showFlgDetails (params) {
      var inlineObjs = [{
        flg: 'delete',
        desc: 'deleted'
      }]
      for (var inlineObj of inlineObjs) {
        var dataRows = params.filter(function (paramRow) {
          return paramRow.flg === inlineObj.flg
        })
        this.objs[inlineObj.flg].total = dataRows.length
        this.objs[inlineObj.flg].rows = dataRows
        var total = dataRows.length
        if (total <= 1) {
          this.desc[inlineObj.flg] = 'Data is ' + inlineObj.desc + ' ' + total + ' row'
        } else {
          this.desc[inlineObj.flg] = 'Data are ' + inlineObj.desc + ' ' + total + ' rows'
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoTableInlineDelete.vue?738c0fd0